/**
 * Created by stonewang on 2017/8/21.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import moment from 'moment';
import { Form, Input, Select, DatePicker, Button, Row, Col, message } from 'antd';
import { DmsTab, RichEditor, SelectRange } from 'Components';
import { sKeylist } from '../../service/dictionary/dataitem';
import { add } from '../../service/notice';
import {showSpin,hideSpin} from 'Utils';
const RangePicker = DatePicker.RangePicker;
const FormItem = Form.Item;

class AddNotice extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      id: parseInt(this.props.params.id, 10),
      detail: {},
      htmlContent: '',
      notice_type: [],
      selectedKeys: [], //抄送范围的ID数组
      selectedNodes: [], //抄送范围的对象数组
    }
    this.handleOk = this.handleOk.bind(this);
    this.openModal = this.openModal.bind(this);
    this.submitHandle = this.submitHandle.bind(this);
  }

  componentWillMount () { //准备数据
    const self = this;
    sKeylist({ sKey: 'notice_type' }).then(res => { //类型
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ notice_type: res.data })
        }
      }, 200);
    })
  }

  componentDidMount () {
    this.mounted = true;
    if (this.state.infoId > 0) {
      /*detail(this.state.infoId).then(res => {
       if(res.status){
       self.setState({
       detail: res.data,
       selectedKeys: res.data.rangeList.map(x => x.toString()),
       selectedNodes: res.data.rangeInfoList,
       htmlContent: res.data.content, //imgUrl
       fileList: [
       {
       uid: -1,
       name: '',
       status: 'done',
       url: res.data.imgUrl,
       thumbUrl: res.data.imgUrl
       }
       ],
       });
       }
       });*/
    }
  }

  cancelHandle () {
    hashHistory.goBack()
  }

  submitHandle () {
    const { id, selectedKeys } = this.state;
    const { validateFields, getFieldsValue } = this.props.form;

    validateFields((errors) => {//表单校验
      if (errors) {
        return
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue() //获取用户输入
      };
      //data.content = self.editor.outputResult();
      data.rangeList = selectedKeys;

      data.effectiveStartDate = data.effective[0] ? data.effective[0]._d : '';
      data.effectiveEndDate = data.effective[1] ? data.effective[1]._d : '';
      delete data.effective;
      // console.log(`你正在提交数据：${JSON.stringify(data)}`);
      showSpin();
      if (id > 0) {
        console.log('debug A');
      } else {
        add(data).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack()
        })
      }
    })
  }

  //发布范围相关
  handleOk = (keys, nodes) => {
    
    const rangeText = nodes.map(x => x.name).join(';');
    this.setState({
      visible: false,
      detail: { ...this.state.detail, rangeText },
      selectedKeys: keys,
      selectedNodes: nodes,
    })
  }

  openModal () {
    this.selectRangModal.showModal()
  }

  render () {
    const { detail, notice_type, id, selectedNodes, selectedKeys, htmlContent } = this.state;
    const { getFieldDecorator } = this.props.form;

    return <div className="dms-body">
      <DmsTab options={[`${id === 0 ? '新建发布' : '编辑信息'}`]} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label="标题：" hasFeedback>
                {getFieldDecorator('title', {
                  rules: [
                    {
                      required: true,
                      message: '请输入标题',
                      min: 1,
                      max: 128
                    }
                  ],
                })(<Input placeholder="请输入标题"/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label="发布范围：" hasFeedback>
                <Input placeholder="请选择发布范围" value={detail.rangeText} onClick={this.openModal}/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="effectiveBox">
                <FormItem label="有效期：" hasFeedback>
                  {getFieldDecorator('effective', {
                    rules: [{ type: 'array', required: true, message: '请设置有效期' }],
                  })(
                    <RangePicker
                      style={{ width: '100%' }}
                      ranges={{ '今天': [moment(), moment()], '本月': [moment(), moment().endOf('month')] }}/>
                  )}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="typeBox">
                <FormItem label="分类：" hasFeedback>
                  {getFieldDecorator('type', {
                    rules: [{ required: true, message: '请选择分类' }],
                  })(
                    <Select
                      showSearch
                      allowClear
                      style={{ width: '100%' }}
                      placeholder="请选择分类"
                    >
                      {
                        notice_type.map((item, key) => {
                          return <Select.Option key={key + ''} value={item.sKey}>{item.name}</Select.Option>
                        })
                      }
                    </Select>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <FormItem label="正文：" hasFeedback>
              {getFieldDecorator('content', {
                initialValue: htmlContent || '',
                valuePropName: 'htmlContent',
                rules: [
                  {
                    required: true,
                    message: '请输入正文'
                  },
                ],
              })(<RichEditor/>)}
            </FormItem>
          </Row>
        </Form>
        {/*<div className="image_text">
         <p>正文</p>
         <RichEditor ref={(node) => { this.editor = node }}
         htmlContent={htmlContent}/>
         </div>*/}
      </div>
      <SelectRange ref={(node) => {
        this.selectRangModal = node;
      }}
                   keys={selectedKeys}
                   nodes={selectedNodes}
                   onOk={this.handleOk}/>
    </div>
  }
}
export default Form.create()(AddNotice)


// WEBPACK FOOTER //
// ./src/routes/notice/add.js